import { render } from "./NoCodeServicePage.vue?vue&type=template&id=1f686cad&scoped=true"
import script from "./NoCodeServicePage.vue?vue&type=script&lang=js"
export * from "./NoCodeServicePage.vue?vue&type=script&lang=js"

import "./NoCodeServicePage.vue?vue&type=style&index=0&id=1f686cad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f686cad"]])

export default __exports__